import { Search } from "lucide-react";
import React, { useEffect, useRef } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";

export const SearchBar = ({
	searchQuery,
	onSearchChange,
	showSearch,
	onShowSearch,
}) => {
	const inputRef = useRef(null);
	const [enableShortcut] = useLocalStorage("enableShortcut", true);

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (enableShortcut && (e.metaKey || e.ctrlKey) && e.key === "f") {
				e.preventDefault();
				onShowSearch(true);
				inputRef.current?.focus();
				inputRef.current?.select();
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [onShowSearch, enableShortcut]);

	useEffect(() => {
		if (showSearch) {
			inputRef.current?.focus();
		}
	}, [showSearch]);

	return (
		<div className="flex-1 relative h-8">
			{(showSearch || searchQuery) && (
				<div className="absolute inset-0 animate-in slide-in-from-top-4 duration-200">
					<input
						ref={inputRef}
						type="text"
						placeholder={`Search PRs by title, author, or project... ${enableShortcut ? "(⌘F)" : ""}`}
						value={searchQuery}
						onChange={(e) => onSearchChange(e.target.value)}
						onBlur={() => {
							if (!searchQuery) {
								onShowSearch(false);
							}
						}}
						className={`w-full h-full px-3 text-sm bg-[var(--color-bg-primary)] border rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-opacity-50 ${
							searchQuery
								? "border-[var(--color-action)] shadow-[inset_0_0_0_1px_var(--color-action)]"
								: "border-[var(--color-border)]"
						}`}
					/>
					<Search
						className={`absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 ${
							searchQuery
								? "text-[var(--color-text-primary)]"
								: "text-[var(--color-text-tertiary)]"
						}`}
					/>
				</div>
			)}
		</div>
	);
};
